module.exports = __webpack_public_path__ + "img/reset_floodlight_step_1.78cd5211.png";